import { AppContext, EMPTY_OBJECT, ModalContext } from 'commons-ui';
import { useContext } from 'react';
import { URL, DOWNTIME_REFUND_RESOURCES } from '../../helper';
import useService from '../../useService';
import { Action, ActionHandlerParams } from '../types';
import { DowntimeRefundAction, EDowntimeRefundStatus } from '../models';

export const makeActionHandler = (action: Action, params: ActionHandlerParams) => {
	const { history, rowData = EMPTY_OBJECT, setConfirmationDialog, setForceUpdateRows } = params;
	const { showAlert } = useContext(AppContext);
	const { approveRefundRequest, rejectRefundRequest, downloadRefundRequest, getRefundRequestStatus } = useService();

	const { setModalConfig } = useContext(ModalContext);
	switch (action.id) {
		case DowntimeRefundAction.APPROVE: {
			const approveRequest = async () => {
				await approveRefundRequest(rowData, showAlert);
				setForceUpdateRows(true);
			};
			return () => {
				setConfirmationDialog({
					show: true,
					header: 'Are you sure you want to approve? After approval this request will go to bulk refund',
					handleAlertConfirmation: approveRequest
				});
			};
		}
		case DowntimeRefundAction.REJECT: {
			const rejectRequest = async () => {
				await rejectRefundRequest(rowData, showAlert);
				setForceUpdateRows(true);
			};
			return () => {
				setConfirmationDialog({
					show: true,
					header: 'Are you sure you want to reject?',
					handleAlertConfirmation: rejectRequest
				});
			};
		}
		case DowntimeRefundAction.DOWNLOAD: {
			return async () => {
				await downloadRefundRequest(rowData, showAlert);
			};
		}
		case DowntimeRefundAction.GET_REFUND_STATUS: {
			return async () => {
				const refundStatus = await getRefundRequestStatus(rowData, showAlert);
				if (refundStatus?.status === EDowntimeRefundStatus.PROCESSING) {
					setModalConfig({
						isOpen: true,
						header: 'Bulk Refund Status',
						content: 'Processing'
					});
				}
				if (refundStatus?.status === EDowntimeRefundStatus.SUCCESS) {
					setModalConfig({
						isOpen: true,
						header: 'Bulk Refund Status',
						content: 'Success'
					});
				}
			};
		}
		case DowntimeRefundAction.ADD:
			return () => {
				history.push({
					pathname: `${URL[DOWNTIME_REFUND_RESOURCES.listRefundRequest]}/create`
				});
			};
		default:
			return () => {};
	}
};

export default {
	makeActionHandler
};
